<template>
  <div class="home">
    <div class="img"><img src="../../assets/logo.png" /></div>
    <div class="imgtips"><img src="../../assets/tips.png" /></div>
    <!-- <div>
      <div class="zbf"><span>主办方</span>：东航期货</div>
      <div class="line"></div>
      <div class="zbf"><span>联合主办</span>：云纪网络&nbsp;&nbsp;i私募</div>
      <div class="line">
      </div>
      <div class="zbf"><span>特别支持</span>：东航金融&nbsp;&nbsp;海通证券 | 基金托管部</div>
    </div> -->
    <!-- <div class="signarrow">
      <div class="signup"><img @click="gosignup" src="../../assets/signup.png" /></div>
    </div> -->
    <singup></singup>
  </div>
</template>
<script>
import singup from "../common/singup.vue"
export default {
  components:{
    singup
  }
}
</script>
<style scoped>
.home {
  height: 100%;
  background: url("../../assets/bg.png") center no-repeat;
  background-size: cover;
  position: relative;
  color: #fff;
}
  .img img {
    width: 100%;
  }
  .imgtips {
    text-align: center;
    padding-top: 15vw;
  }
  .imgtips img {
    width: 50%;
  }
  .zbf {
    width: 100vw;
    margin: 0 auto;
    font-size: 4vw;
    text-align: center;
  }
  .zbf span {
    display: inline-block;
    width: 16.5vw;
    /*text-align:justify;*/
    /*text-justify:distribute-all-lines;*/
    /*text-align-last:justify;*/
    letter-spacing: 0;
  }
  .line {
    height: 6vw;
    background: url("../../assets/fgx.png") no-repeat center;
    background-size: contain;
    width: 80vw;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/home.vue